/*
  All Star quick-add.

  Custom product cards (collection grid, homepage hit packs, gift spotlight,
  related products) post a plain form to /cart/add, which navigates away to the
  cart page. This intercepts those submits and adds via AJAX instead, then hands
  the response to the theme's own <cart-drawer> so the drawer opens and the
  header count bubble re-renders — the same section-rendering flow Refresh's
  native product-form uses.

  Only single-variant products render these forms; multi-variant cards link to
  the product page and are untouched.
*/
(function () {
  // as-design-head is rendered by every as-* section, so this file can be
  // requested more than once per page. Bind the delegated listener only once.
  if (window.__allStarQuickAddReady) return;
  window.__allStarQuickAddReady = true;

  var FORM_SELECTOR = 'form.as-quick-add';

  function getCart() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  /*
    The theme renders <cart-drawer class="drawer is-empty"> when the cart is
    empty at page load, but renderContents only swaps the inner #CartDrawer
    markup — so that class goes stale after the first add and the drawer keeps
    showing its empty-state layout (header hidden, "cart is empty" block shown).
    Re-sync it from what the drawer actually contains.
  */
  function syncEmptyState() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var hasItems = !!drawer.querySelector('.cart-item');
    drawer.classList.toggle('is-empty', !hasItems);
  }

  /*
    Free-shipping bar. Both cart surfaces re-render server-side on quantity
    change, which already refreshes the markup. This re-syncs from /cart.js as
    a safety net for any path that mutates the cart without a re-render.
  */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + amount;
  }

  function refreshShippingBars() {
    var bars = document.querySelectorAll('[data-as-ship]');
    if (!bars.length) return;
    fetch(window.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        bars.forEach(function (bar) {
          var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
          if (!threshold) return;
          var subtotal = cart.total_price;
          var remaining = threshold - subtotal;
          var pct = Math.min(100, (subtotal / threshold) * 100);
          var fill = bar.querySelector('[data-as-ship-fill]');
          var text = bar.querySelector('[data-as-ship-text]');
          if (fill) fill.style.width = pct + '%';
          if (!text) return;
          if (remaining > 0) {
            text.innerHTML = 'Add <span class="as-ship__amount">' + formatMoney(remaining) +
              '</span> more for free U.S. shipping';
          } else {
            text.textContent = bar.getAttribute('data-reached') || "You've got free U.S. shipping";
          }
        });
      })
      .catch(function () {});
  }

  // Keep it correct for every path that re-renders the cart (quick add,
  // native product form, quantity changes, remove).
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(function () {
        syncEmptyState();
        refreshShippingBars();
      });
    });
  }

  function clearError(form) {
    var existing = form.parentElement && form.parentElement.querySelector('.as-quick-add__error');
    if (existing) existing.remove();
  }

  function showError(form, message) {
    clearError(form);
    var el = document.createElement('span');
    el.className = 'as-quick-add__error';
    el.setAttribute('role', 'alert');
    el.textContent = message;
    form.insertAdjacentElement('afterend', el);
  }

  function setLoading(button, loading) {
    if (!button) return;
    if (loading) {
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');
      if (!button.dataset.label) button.dataset.label = button.textContent;
      button.textContent = 'Adding...';
    } else {
      button.removeAttribute('aria-disabled');
      button.removeAttribute('aria-busy');
      button.classList.remove('is-loading');
      if (button.dataset.label) button.textContent = button.dataset.label;
    }
  }

  // Signal the drawer as a dialog trigger, matching native product-form a11y.
  function markButtons() {
    if (!document.querySelector('cart-drawer')) return;
    document.querySelectorAll(FORM_SELECTOR + ' [type="submit"]').forEach(function (btn) {
      btn.setAttribute('aria-haspopup', 'dialog');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markButtons);
  } else {
    markButtons();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest ? event.target.closest(FORM_SELECTOR) : null;
    if (!form) return;

    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    if (button && button.getAttribute('aria-disabled') === 'true') return;

    clearError(form);
    setLoading(button, true);

    var cart = getCart();
    var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: {} };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData(form);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) { return section.id; })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then(function (response) { return response.json(); })
      .then(function (response) {
        // Shopify returns a `status` field only when the add failed
        // (sold out, quantity unavailable, etc).
        if (response.status) {
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'allstar-quick-add',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
          }
          showError(form, response.description || response.message || 'Could not add to cart.');
          return;
        }

        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        cart.renderContents(response);
        setTimeout(syncEmptyState);

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'allstar-quick-add',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        }
      })
      .catch(function () {
        showError(form, 'Something went wrong. Please try again.');
      })
      .finally(function () {
        setLoading(button, false);
      });
  });
})();
